import { configureStore } from "@reduxjs/toolkit";

// ---- import from local reducers ----
import authReducer from "./slices/AuthSlice";
import accessReducer from "./slices/AccessSlice";
import roleReducer from "./slices/RoleSlice";
import moduleReducer from "./slices/ModuleSlice";
import rolePermissionReducer from "./slices/RolePermissionSlice";
import userReducer from "./slices/UserSlice";
import positionReducer from "./slices/PositionSlice";
import buildingReducer from "./slices/BuildingSlice";
import controlDeviceReducer from "./slices/ControlDeviceSlice";
import residentReducer from "./slices/ResidentSlice";
import elevatorReducer from "./slices/ElevatorSlice";
import floorReducer from "./slices/FloorSlice";
import applyReducer from "./slices/ApplySlice";
import elevCtrlHistoryReducer from "./slices/ElevCtrlHistorySlice";
import controlCodeReducer from "./slices/ControlCodeSlice";

const store = configureStore({
    reducer: {
        auth: authReducer,
        access: accessReducer,
        role: roleReducer,
        module: moduleReducer,
        rolePermission: rolePermissionReducer,
        user: userReducer,
        position: positionReducer,
        building: buildingReducer,
        controlDevice: controlDeviceReducer,
        resident: residentReducer,
        elevator: elevatorReducer,
        floor: floorReducer,
        apply: applyReducer,
        elevCtrlHistory: elevCtrlHistoryReducer,
        controlCode: controlCodeReducer,
    }
});

export default store;